"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiRouterConversationsGetConversationsV1StateEnum = exports.AiRouterConversationsGetConversationsV1ConversationTypeEnum = exports.AiRouterConversationsCreateConversationByTypeV1IncludeEnum = exports.AiRouterConversationsCreateConversationByTypeV1ConversationTypeEnum = exports.AiRouterApi = exports.AiRouterApiFactory = exports.AiRouterApiFp = exports.AiRouterApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * AiRouterApi - axios parameter creator
 */
const AiRouterApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Generates AI recommendations based on a conversation
         * @summary Generate AI recommendations
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {AIRecommendationGenerateRequest} aIRecommendationGenerateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterAiRecommendationsGenerateAIRecommendationsV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, aIRecommendationGenerateRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterAiRecommendationsGenerateAIRecommendationsV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'aIRecommendationGenerateRequest' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterAiRecommendationsGenerateAIRecommendationsV1', 'aIRecommendationGenerateRequest', aIRecommendationGenerateRequest);
            const localVarPath = `/v1/ai-router/ai-recommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication authz_circle_jwt_data_permission required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/ai-recommendations`,
                sdkMethod: 'aiRouterAiRecommendationsGenerateAIRecommendationsV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(aIRecommendationGenerateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves AI recommendations for a Circle recipient. The recipient is derived from the Circle JWT authorization token. If conversation_id is provided, returns recommendations for that specific onboarding conversation; otherwise falls back to the most recent onboarding conversation. Returns empty recommendations array if no conversations exist. WARNING: Only to be used by RBC Service, not for direct client use since Content Rec\'s must be passed through RBC security filtering rules
         * @summary Get AI recommendations
         * @param {string} [conversationId] Optional UUID of a specific onboarding conversation to retrieve recommendations for. If omitted, returns recommendations for the most recent onboarding conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterAiRecommendationsGetAIRecommendationsV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ conversationId, }, options = {}) {
            const localVarPath = `/v1/ai-router/ai-recommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication authz_circle_jwt_data_permission required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            if (conversationId !== undefined) {
                localVarQueryParameter['conversation_id'] = conversationId;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/ai-recommendations`,
                sdkMethod: 'aiRouterAiRecommendationsGetAIRecommendationsV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a new AI conversation based on the conversation type.  **Note:** User goals or topics are automatically fetched from the Usercrypt Service using the authenticated recipient ID. Use the `include` query parameter to select which data is included (default: goals).
         * @summary Create an AI conversation
         * @param {AiRouterConversationsCreateConversationByTypeV1ConversationTypeEnum} conversationType The type of conversation (e.g., onboarding, journaling)
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {ConversationRequest} conversationRequest
         * @param {AiRouterConversationsCreateConversationByTypeV1IncludeEnum} [include] Which data to include with the conversation request. Only applies to onboarding conversations; ignored for journaling. Valid values are \&quot;goals\&quot; or \&quot;topics\&quot;. Defaults to \&quot;goals\&quot; for backward compatibility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterConversationsCreateConversationByTypeV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ conversationType, circleAuthorizationToken, conversationRequest, include, }, options = {}) {
            // verify required parameter 'conversationType' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterConversationsCreateConversationByTypeV1', 'conversationType', conversationType);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterConversationsCreateConversationByTypeV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'conversationRequest' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterConversationsCreateConversationByTypeV1', 'conversationRequest', conversationRequest);
            const localVarPath = `/v1/ai-router/conversations/{conversation_type}`.replace('{conversation_type}', encodeURIComponent(String(conversationType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication authz_circle_jwt_data_permission required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/conversations/{conversation_type}`,
                sdkMethod: 'aiRouterConversationsCreateConversationByTypeV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(conversationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves all items (messages) for a specific conversation in chronological order. Returns user and assistant messages in a format inspired by the OpenAI Conversations API.
         * @summary Get conversation items
         * @param {string} conversationId The conversation ID to retrieve items for
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterConversationsGetConversationItemsV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ conversationId, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'conversationId' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterConversationsGetConversationItemsV1', 'conversationId', conversationId);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterConversationsGetConversationItemsV1', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v1/ai-router/conversations/{conversation_id}/items`.replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication authz_circle_jwt_data_permission required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/conversations/{conversation_id}/items`,
                sdkMethod: 'aiRouterConversationsGetConversationItemsV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves all non-deleted conversations for a specific recipient and conversation type
         * @summary Get conversations for a recipient
         * @param {AiRouterConversationsGetConversationsV1ConversationTypeEnum} conversationType The type of conversation to filter by
         * @param {number} recipientId The Circle recipient ID to get conversations for
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {AiRouterConversationsGetConversationsV1StateEnum} [state] Optional filter for conversation state
         * @param {string} [pageCursor] Cursor for keyset pagination. Pass the value from links.next to fetch the next page.
         * @param {number} [pageSize] Number of conversations per page (default 25, max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterConversationsGetConversationsV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ conversationType, recipientId, circleAuthorizationToken, state, pageCursor, pageSize, }, options = {}) {
            // verify required parameter 'conversationType' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterConversationsGetConversationsV1', 'conversationType', conversationType);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterConversationsGetConversationsV1', 'recipientId', recipientId);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterConversationsGetConversationsV1', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v1/ai-router/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication authz_circle_jwt_data_permission required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            if (conversationType !== undefined) {
                localVarQueryParameter['conversation_type'] = conversationType;
            }
            if (recipientId !== undefined) {
                localVarQueryParameter['recipient_id'] = recipientId;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (pageCursor !== undefined) {
                localVarQueryParameter['page_cursor'] = pageCursor;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/conversations`,
                sdkMethod: 'aiRouterConversationsGetConversationsV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Scans failed inputs of a given operation type within a creation-time window and re-enqueues them onto the in-process pipeline worker. This endpoint is append-only:  failed inputs are never mutated. The pipeline worker creates a new input row for each  attempt, which becomes the conversation\'s latest — so a subsequent retry call will  not re-process the same conversation.
         * @summary Re-queue failed Content RAG pipeline jobs
         * @param {PipelineRetryRequest} pipelineRetryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterPipelinesRetryV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ pipelineRetryRequest }, options = {}) {
            // verify required parameter 'pipelineRetryRequest' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterPipelinesRetryV1', 'pipelineRetryRequest', pipelineRetryRequest);
            const localVarPath = `/v1/ai-router/pipelines/retry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authz_permissions required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, 'authz_permissions', ['write:admin'], configuration);
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication GoogleBearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/pipelines/retry`,
                sdkMethod: 'aiRouterPipelinesRetryV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pipelineRetryRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Generic endpoint for handling Google Cloud Pub/Sub push subscription messages This endpoint receives push messages from Google Cloud Pub/Sub and processes them asynchronously. The endpoint validates the Pub/Sub message format and routes events to appropriate handlers based on event type.
         * @summary Pub/Sub message receiving endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterPubsubV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({}, options = {}) {
            const localVarPath = `/v1/ai-router/pubsub`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication GoogleBearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/pubsub`,
                sdkMethod: 'aiRouterPubsubV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Copies all Conversations, Inputs, Responses, and related data from the source User Circle (recipient_id) to a target User Circle. The operation is atomic and idempotent. If the target circle already has any data, the copy operation is skipped and returns 204 No Content without making changes.  Authorization: callers must be either a service (M2M) token holding the `write:admin` permission, or a member whose Circle JWT recipient matches the `recipient_id` path parameter and grants create permission on the AI data classes. A bare authenticated token without either is rejected.
         * @summary Copy conversations and related data to a new User Circle
         * @param {number} recipientId The source User Circle ID (recipient_id) to copy data from
         * @param {RecipientCopyRequest} recipientCopyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsCopyRecipientDataV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, recipientCopyRequest, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterRecipientsCopyRecipientDataV1', 'recipientId', recipientId);
            // verify required parameter 'recipientCopyRequest' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterRecipientsCopyRecipientDataV1', 'recipientCopyRequest', recipientCopyRequest);
            const localVarPath = `/v1/ai-router/recipients/{recipient_id}/copy`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authz_permissions required
            // oauth required
            yield (0, common_1.setOAuthToObject)(localVarHeaderParameter, 'authz_permissions', ['write:admin'], configuration);
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication authz_circle_jwt_data_permission required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/recipients/{recipient_id}/copy`,
                sdkMethod: 'aiRouterRecipientsCopyRecipientDataV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(recipientCopyRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Soft-deletes a conversation by setting its deleted_at timestamp. The conversation will no longer appear in any GET queries.
         * @summary Soft delete a conversation
         * @param {number} recipientId The Circle recipient ID that owns the conversation
         * @param {string} conversationId The conversation ID to delete
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsDeleteConversationV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, conversationId, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterRecipientsDeleteConversationV1', 'recipientId', recipientId);
            // verify required parameter 'conversationId' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterRecipientsDeleteConversationV1', 'conversationId', conversationId);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterRecipientsDeleteConversationV1', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v1/ai-router/recipients/{recipient_id}/conversations/{conversation_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication authz_circle_jwt_data_permission required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/recipients/{recipient_id}/conversations/{conversation_id}`,
                sdkMethod: 'aiRouterRecipientsDeleteConversationV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Hard-deletes all conversations, inputs, responses, and feedback for the given recipient ID. Unlike soft-delete, this operation is irreversible and physically removes the rows from the database. Cascading foreign key constraints ensure that all child records (inputs, responses, feedback) are removed when their parent conversations are deleted.
         * @summary Permanently expunge all data for a recipient
         * @param {number} recipientId The Circle recipient ID whose data will be permanently deleted
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsExpungeV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterRecipientsExpungeV1', 'recipientId', recipientId);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterRecipientsExpungeV1', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v1/ai-router/recipients/{recipient_id}/expunge`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication authz_circle_jwt_data_permission required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/recipients/{recipient_id}/expunge`,
                sdkMethod: 'aiRouterRecipientsExpungeV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the total time spent across all journaling conversations for a recipient (including deleted ones).
         * @summary Get total journaling time spent
         * @param {number} recipientId The Circle recipient ID
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsGetJournalingTimeSpentV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterRecipientsGetJournalingTimeSpentV1', 'recipientId', recipientId);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterRecipientsGetJournalingTimeSpentV1', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v1/ai-router/recipients/{recipient_id}/journaling/time-spent`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication authz_circle_jwt_data_permission required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/recipients/{recipient_id}/journaling/time-spent`,
                sdkMethod: 'aiRouterRecipientsGetJournalingTimeSpentV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Increments the time_spent_seconds for a conversation by the specified amount. Multiple calls accumulate additively. Cannot update deleted or completed conversations.
         * @summary Update conversation time spent
         * @param {number} recipientId The Circle recipient ID that owns the conversation
         * @param {string} conversationId The conversation ID to update
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {IncrementConversationTimeSpentRequest} incrementConversationTimeSpentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsUpdateConversationTimeSpentV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, conversationId, circleAuthorizationToken, incrementConversationTimeSpentRequest, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterRecipientsUpdateConversationTimeSpentV1', 'recipientId', recipientId);
            // verify required parameter 'conversationId' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterRecipientsUpdateConversationTimeSpentV1', 'conversationId', conversationId);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterRecipientsUpdateConversationTimeSpentV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'incrementConversationTimeSpentRequest' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterRecipientsUpdateConversationTimeSpentV1', 'incrementConversationTimeSpentRequest', incrementConversationTimeSpentRequest);
            const localVarPath = `/v1/ai-router/recipients/{recipient_id}/conversations/{conversation_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication authz_circle_jwt_data_permission required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/recipients/{recipient_id}/conversations/{conversation_id}`,
                sdkMethod: 'aiRouterRecipientsUpdateConversationTimeSpentV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(incrementConversationTimeSpentRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Submits user feedback for AI-generated content, persisting it to the database and sending to BigQuery and Databricks.  Supports three types of feedback: - **Content Level (ai_content_rec_single)**: Feedback for a single piece of content (e.g., a specific guide) - **Care Plan Level (ai_content_rec_group)**: Feedback for a group of content recommendations (e.g., full care plan) - **Echo Back (ai_echo_back)**: Feedback for empathetic responses generated in the Echo Back flow  All types are associated with the same Databricks trace ID from the response. The contentId is required only for ai_content_rec_single to identify the specific content being rated. For ai_content_rec_group and ai_echo_back, the response_id provides sufficient context.
         * @summary Submit user feedback for AI content
         * @param {string} responseId The ID of the AI response - used to retrieve the Databricks trace ID for evaluation tracking
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {FeedbackRequest} feedbackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterResponsesCreateFeedbackV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ responseId, circleAuthorizationToken, feedbackRequest, }, options = {}) {
            // verify required parameter 'responseId' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterResponsesCreateFeedbackV1', 'responseId', responseId);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterResponsesCreateFeedbackV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'feedbackRequest' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterResponsesCreateFeedbackV1', 'feedbackRequest', feedbackRequest);
            const localVarPath = `/v1/ai-router/responses/{response_id}/feedback`.replace('{response_id}', encodeURIComponent(String(responseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication authz_circle_jwt_data_permission required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/responses/{response_id}/feedback`,
                sdkMethod: 'aiRouterResponsesCreateFeedbackV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(feedbackRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Adds a new response to an existing journaling conversation. The conversation must already exist, not be completed, and be of type \"journaling\". Only journaling conversations are supported — onboarding conversations are single-turn and should use PUT /v1/ai-router/conversations/onboarding instead.
         * @summary Continue an existing journaling conversation
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {CreateResponseRequest} createResponseRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterResponsesCreateResponseV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, createResponseRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterResponsesCreateResponseV1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'createResponseRequest' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterResponsesCreateResponseV1', 'createResponseRequest', createResponseRequest);
            const localVarPath = `/v1/ai-router/responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication authz_circle_jwt_data_permission required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/responses`,
                sdkMethod: 'aiRouterResponsesCreateResponseV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createResponseRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves all feedback submitted for a specific response. Returns feedback filtered by the authenticated user\'s recipient_id for proper authorization. Used by clients to determine which feedback button state to show (thumbs up, thumbs down, or no vote).
         * @summary Get feedback for a response
         * @param {string} responseId The ID of the AI response to retrieve feedback for
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterResponsesGetFeedbackV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ responseId, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'responseId' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterResponsesGetFeedbackV1', 'responseId', responseId);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('aiRouterResponsesGetFeedbackV1', 'circleAuthorizationToken', circleAuthorizationToken);
            const localVarPath = `/v1/ai-router/responses/{response_id}/feedback`.replace('{response_id}', encodeURIComponent(String(responseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authn_oneid_bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            // authentication authz_circle_jwt_data_permission required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'Circle-Authorization-Token', configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/ai-router/responses/{response_id}/feedback`,
                sdkMethod: 'aiRouterResponsesGetFeedbackV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AiRouterApiAxiosParamCreator = AiRouterApiAxiosParamCreator;
/**
 * AiRouterApi - functional programming interface
 */
const AiRouterApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AiRouterApiAxiosParamCreator)(configuration);
    return {
        /**
         * Generates AI recommendations based on a conversation
         * @summary Generate AI recommendations
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {AIRecommendationGenerateRequest} aIRecommendationGenerateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterAiRecommendationsGenerateAIRecommendationsV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterAiRecommendationsGenerateAIRecommendationsV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterAiRecommendationsGenerateAIRecommendationsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves AI recommendations for a Circle recipient. The recipient is derived from the Circle JWT authorization token. If conversation_id is provided, returns recommendations for that specific onboarding conversation; otherwise falls back to the most recent onboarding conversation. Returns empty recommendations array if no conversations exist. WARNING: Only to be used by RBC Service, not for direct client use since Content Rec\'s must be passed through RBC security filtering rules
         * @summary Get AI recommendations
         * @param {string} [conversationId] Optional UUID of a specific onboarding conversation to retrieve recommendations for. If omitted, returns recommendations for the most recent onboarding conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterAiRecommendationsGetAIRecommendationsV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterAiRecommendationsGetAIRecommendationsV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterAiRecommendationsGetAIRecommendationsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creates a new AI conversation based on the conversation type.  **Note:** User goals or topics are automatically fetched from the Usercrypt Service using the authenticated recipient ID. Use the `include` query parameter to select which data is included (default: goals).
         * @summary Create an AI conversation
         * @param {AiRouterConversationsCreateConversationByTypeV1ConversationTypeEnum} conversationType The type of conversation (e.g., onboarding, journaling)
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {ConversationRequest} conversationRequest
         * @param {AiRouterConversationsCreateConversationByTypeV1IncludeEnum} [include] Which data to include with the conversation request. Only applies to onboarding conversations; ignored for journaling. Valid values are \&quot;goals\&quot; or \&quot;topics\&quot;. Defaults to \&quot;goals\&quot; for backward compatibility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterConversationsCreateConversationByTypeV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterConversationsCreateConversationByTypeV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterConversationsCreateConversationByTypeV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves all items (messages) for a specific conversation in chronological order. Returns user and assistant messages in a format inspired by the OpenAI Conversations API.
         * @summary Get conversation items
         * @param {string} conversationId The conversation ID to retrieve items for
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterConversationsGetConversationItemsV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterConversationsGetConversationItemsV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterConversationsGetConversationItemsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves all non-deleted conversations for a specific recipient and conversation type
         * @summary Get conversations for a recipient
         * @param {AiRouterConversationsGetConversationsV1ConversationTypeEnum} conversationType The type of conversation to filter by
         * @param {number} recipientId The Circle recipient ID to get conversations for
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {AiRouterConversationsGetConversationsV1StateEnum} [state] Optional filter for conversation state
         * @param {string} [pageCursor] Cursor for keyset pagination. Pass the value from links.next to fetch the next page.
         * @param {number} [pageSize] Number of conversations per page (default 25, max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterConversationsGetConversationsV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterConversationsGetConversationsV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterConversationsGetConversationsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Scans failed inputs of a given operation type within a creation-time window and re-enqueues them onto the in-process pipeline worker. This endpoint is append-only:  failed inputs are never mutated. The pipeline worker creates a new input row for each  attempt, which becomes the conversation\'s latest — so a subsequent retry call will  not re-process the same conversation.
         * @summary Re-queue failed Content RAG pipeline jobs
         * @param {PipelineRetryRequest} pipelineRetryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterPipelinesRetryV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterPipelinesRetryV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterPipelinesRetryV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Generic endpoint for handling Google Cloud Pub/Sub push subscription messages This endpoint receives push messages from Google Cloud Pub/Sub and processes them asynchronously. The endpoint validates the Pub/Sub message format and routes events to appropriate handlers based on event type.
         * @summary Pub/Sub message receiving endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterPubsubV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterPubsubV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterPubsubV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Copies all Conversations, Inputs, Responses, and related data from the source User Circle (recipient_id) to a target User Circle. The operation is atomic and idempotent. If the target circle already has any data, the copy operation is skipped and returns 204 No Content without making changes.  Authorization: callers must be either a service (M2M) token holding the `write:admin` permission, or a member whose Circle JWT recipient matches the `recipient_id` path parameter and grants create permission on the AI data classes. A bare authenticated token without either is rejected.
         * @summary Copy conversations and related data to a new User Circle
         * @param {number} recipientId The source User Circle ID (recipient_id) to copy data from
         * @param {RecipientCopyRequest} recipientCopyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsCopyRecipientDataV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterRecipientsCopyRecipientDataV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterRecipientsCopyRecipientDataV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Soft-deletes a conversation by setting its deleted_at timestamp. The conversation will no longer appear in any GET queries.
         * @summary Soft delete a conversation
         * @param {number} recipientId The Circle recipient ID that owns the conversation
         * @param {string} conversationId The conversation ID to delete
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsDeleteConversationV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterRecipientsDeleteConversationV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterRecipientsDeleteConversationV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Hard-deletes all conversations, inputs, responses, and feedback for the given recipient ID. Unlike soft-delete, this operation is irreversible and physically removes the rows from the database. Cascading foreign key constraints ensure that all child records (inputs, responses, feedback) are removed when their parent conversations are deleted.
         * @summary Permanently expunge all data for a recipient
         * @param {number} recipientId The Circle recipient ID whose data will be permanently deleted
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsExpungeV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterRecipientsExpungeV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterRecipientsExpungeV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns the total time spent across all journaling conversations for a recipient (including deleted ones).
         * @summary Get total journaling time spent
         * @param {number} recipientId The Circle recipient ID
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsGetJournalingTimeSpentV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterRecipientsGetJournalingTimeSpentV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterRecipientsGetJournalingTimeSpentV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Increments the time_spent_seconds for a conversation by the specified amount. Multiple calls accumulate additively. Cannot update deleted or completed conversations.
         * @summary Update conversation time spent
         * @param {number} recipientId The Circle recipient ID that owns the conversation
         * @param {string} conversationId The conversation ID to update
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {IncrementConversationTimeSpentRequest} incrementConversationTimeSpentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsUpdateConversationTimeSpentV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterRecipientsUpdateConversationTimeSpentV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterRecipientsUpdateConversationTimeSpentV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Submits user feedback for AI-generated content, persisting it to the database and sending to BigQuery and Databricks.  Supports three types of feedback: - **Content Level (ai_content_rec_single)**: Feedback for a single piece of content (e.g., a specific guide) - **Care Plan Level (ai_content_rec_group)**: Feedback for a group of content recommendations (e.g., full care plan) - **Echo Back (ai_echo_back)**: Feedback for empathetic responses generated in the Echo Back flow  All types are associated with the same Databricks trace ID from the response. The contentId is required only for ai_content_rec_single to identify the specific content being rated. For ai_content_rec_group and ai_echo_back, the response_id provides sufficient context.
         * @summary Submit user feedback for AI content
         * @param {string} responseId The ID of the AI response - used to retrieve the Databricks trace ID for evaluation tracking
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {FeedbackRequest} feedbackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterResponsesCreateFeedbackV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterResponsesCreateFeedbackV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterResponsesCreateFeedbackV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Adds a new response to an existing journaling conversation. The conversation must already exist, not be completed, and be of type \"journaling\". Only journaling conversations are supported — onboarding conversations are single-turn and should use PUT /v1/ai-router/conversations/onboarding instead.
         * @summary Continue an existing journaling conversation
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {CreateResponseRequest} createResponseRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterResponsesCreateResponseV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterResponsesCreateResponseV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterResponsesCreateResponseV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves all feedback submitted for a specific response. Returns feedback filtered by the authenticated user\'s recipient_id for proper authorization. Used by clients to determine which feedback button state to show (thumbs up, thumbs down, or no vote).
         * @summary Get feedback for a response
         * @param {string} responseId The ID of the AI response to retrieve feedback for
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterResponsesGetFeedbackV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiRouterResponsesGetFeedbackV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AiRouterApi.aiRouterResponsesGetFeedbackV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.AiRouterApiFp = AiRouterApiFp;
/**
 * AiRouterApi - factory interface
 */
const AiRouterApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AiRouterApiFp)(configuration);
    return {
        /**
         * Generates AI recommendations based on a conversation
         * @summary Generate AI recommendations
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {AIRecommendationGenerateRequest} aIRecommendationGenerateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterAiRecommendationsGenerateAIRecommendationsV1(params, options) {
            return localVarFp
                .aiRouterAiRecommendationsGenerateAIRecommendationsV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves AI recommendations for a Circle recipient. The recipient is derived from the Circle JWT authorization token. If conversation_id is provided, returns recommendations for that specific onboarding conversation; otherwise falls back to the most recent onboarding conversation. Returns empty recommendations array if no conversations exist. WARNING: Only to be used by RBC Service, not for direct client use since Content Rec\'s must be passed through RBC security filtering rules
         * @summary Get AI recommendations
         * @param {string} [conversationId] Optional UUID of a specific onboarding conversation to retrieve recommendations for. If omitted, returns recommendations for the most recent onboarding conversation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterAiRecommendationsGetAIRecommendationsV1(params, options) {
            return localVarFp
                .aiRouterAiRecommendationsGetAIRecommendationsV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Creates a new AI conversation based on the conversation type.  **Note:** User goals or topics are automatically fetched from the Usercrypt Service using the authenticated recipient ID. Use the `include` query parameter to select which data is included (default: goals).
         * @summary Create an AI conversation
         * @param {AiRouterConversationsCreateConversationByTypeV1ConversationTypeEnum} conversationType The type of conversation (e.g., onboarding, journaling)
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {ConversationRequest} conversationRequest
         * @param {AiRouterConversationsCreateConversationByTypeV1IncludeEnum} [include] Which data to include with the conversation request. Only applies to onboarding conversations; ignored for journaling. Valid values are \&quot;goals\&quot; or \&quot;topics\&quot;. Defaults to \&quot;goals\&quot; for backward compatibility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterConversationsCreateConversationByTypeV1(params, options) {
            return localVarFp
                .aiRouterConversationsCreateConversationByTypeV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all items (messages) for a specific conversation in chronological order. Returns user and assistant messages in a format inspired by the OpenAI Conversations API.
         * @summary Get conversation items
         * @param {string} conversationId The conversation ID to retrieve items for
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterConversationsGetConversationItemsV1(params, options) {
            return localVarFp
                .aiRouterConversationsGetConversationItemsV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all non-deleted conversations for a specific recipient and conversation type
         * @summary Get conversations for a recipient
         * @param {AiRouterConversationsGetConversationsV1ConversationTypeEnum} conversationType The type of conversation to filter by
         * @param {number} recipientId The Circle recipient ID to get conversations for
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {AiRouterConversationsGetConversationsV1StateEnum} [state] Optional filter for conversation state
         * @param {string} [pageCursor] Cursor for keyset pagination. Pass the value from links.next to fetch the next page.
         * @param {number} [pageSize] Number of conversations per page (default 25, max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterConversationsGetConversationsV1(params, options) {
            return localVarFp
                .aiRouterConversationsGetConversationsV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Scans failed inputs of a given operation type within a creation-time window and re-enqueues them onto the in-process pipeline worker. This endpoint is append-only:  failed inputs are never mutated. The pipeline worker creates a new input row for each  attempt, which becomes the conversation\'s latest — so a subsequent retry call will  not re-process the same conversation.
         * @summary Re-queue failed Content RAG pipeline jobs
         * @param {PipelineRetryRequest} pipelineRetryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterPipelinesRetryV1(params, options) {
            return localVarFp
                .aiRouterPipelinesRetryV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Generic endpoint for handling Google Cloud Pub/Sub push subscription messages This endpoint receives push messages from Google Cloud Pub/Sub and processes them asynchronously. The endpoint validates the Pub/Sub message format and routes events to appropriate handlers based on event type.
         * @summary Pub/Sub message receiving endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterPubsubV1(params, options) {
            return localVarFp
                .aiRouterPubsubV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Copies all Conversations, Inputs, Responses, and related data from the source User Circle (recipient_id) to a target User Circle. The operation is atomic and idempotent. If the target circle already has any data, the copy operation is skipped and returns 204 No Content without making changes.  Authorization: callers must be either a service (M2M) token holding the `write:admin` permission, or a member whose Circle JWT recipient matches the `recipient_id` path parameter and grants create permission on the AI data classes. A bare authenticated token without either is rejected.
         * @summary Copy conversations and related data to a new User Circle
         * @param {number} recipientId The source User Circle ID (recipient_id) to copy data from
         * @param {RecipientCopyRequest} recipientCopyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsCopyRecipientDataV1(params, options) {
            return localVarFp
                .aiRouterRecipientsCopyRecipientDataV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Soft-deletes a conversation by setting its deleted_at timestamp. The conversation will no longer appear in any GET queries.
         * @summary Soft delete a conversation
         * @param {number} recipientId The Circle recipient ID that owns the conversation
         * @param {string} conversationId The conversation ID to delete
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsDeleteConversationV1(params, options) {
            return localVarFp
                .aiRouterRecipientsDeleteConversationV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Hard-deletes all conversations, inputs, responses, and feedback for the given recipient ID. Unlike soft-delete, this operation is irreversible and physically removes the rows from the database. Cascading foreign key constraints ensure that all child records (inputs, responses, feedback) are removed when their parent conversations are deleted.
         * @summary Permanently expunge all data for a recipient
         * @param {number} recipientId The Circle recipient ID whose data will be permanently deleted
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsExpungeV1(params, options) {
            return localVarFp
                .aiRouterRecipientsExpungeV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns the total time spent across all journaling conversations for a recipient (including deleted ones).
         * @summary Get total journaling time spent
         * @param {number} recipientId The Circle recipient ID
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsGetJournalingTimeSpentV1(params, options) {
            return localVarFp
                .aiRouterRecipientsGetJournalingTimeSpentV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Increments the time_spent_seconds for a conversation by the specified amount. Multiple calls accumulate additively. Cannot update deleted or completed conversations.
         * @summary Update conversation time spent
         * @param {number} recipientId The Circle recipient ID that owns the conversation
         * @param {string} conversationId The conversation ID to update
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {IncrementConversationTimeSpentRequest} incrementConversationTimeSpentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterRecipientsUpdateConversationTimeSpentV1(params, options) {
            return localVarFp
                .aiRouterRecipientsUpdateConversationTimeSpentV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Submits user feedback for AI-generated content, persisting it to the database and sending to BigQuery and Databricks.  Supports three types of feedback: - **Content Level (ai_content_rec_single)**: Feedback for a single piece of content (e.g., a specific guide) - **Care Plan Level (ai_content_rec_group)**: Feedback for a group of content recommendations (e.g., full care plan) - **Echo Back (ai_echo_back)**: Feedback for empathetic responses generated in the Echo Back flow  All types are associated with the same Databricks trace ID from the response. The contentId is required only for ai_content_rec_single to identify the specific content being rated. For ai_content_rec_group and ai_echo_back, the response_id provides sufficient context.
         * @summary Submit user feedback for AI content
         * @param {string} responseId The ID of the AI response - used to retrieve the Databricks trace ID for evaluation tracking
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {FeedbackRequest} feedbackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterResponsesCreateFeedbackV1(params, options) {
            return localVarFp
                .aiRouterResponsesCreateFeedbackV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Adds a new response to an existing journaling conversation. The conversation must already exist, not be completed, and be of type \"journaling\". Only journaling conversations are supported — onboarding conversations are single-turn and should use PUT /v1/ai-router/conversations/onboarding instead.
         * @summary Continue an existing journaling conversation
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {CreateResponseRequest} createResponseRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterResponsesCreateResponseV1(params, options) {
            return localVarFp
                .aiRouterResponsesCreateResponseV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all feedback submitted for a specific response. Returns feedback filtered by the authenticated user\'s recipient_id for proper authorization. Used by clients to determine which feedback button state to show (thumbs up, thumbs down, or no vote).
         * @summary Get feedback for a response
         * @param {string} responseId The ID of the AI response to retrieve feedback for
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiRouterResponsesGetFeedbackV1(params, options) {
            return localVarFp
                .aiRouterResponsesGetFeedbackV1(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.AiRouterApiFactory = AiRouterApiFactory;
/**
 * AiRouterApi - object-oriented interface
 */
class AiRouterApi extends base_1.BaseAPI {
    /**
     * URL `/v1/ai-router/ai-recommendations`
     * Generates AI recommendations based on a conversation
     * @summary Generate AI recommendations
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {AIRecommendationGenerateRequest} aIRecommendationGenerateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterAiRecommendationsGenerateAIRecommendationsV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterAiRecommendationsGenerateAIRecommendationsV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/ai-recommendations`
     * Retrieves AI recommendations for a Circle recipient. The recipient is derived from the Circle JWT authorization token. If conversation_id is provided, returns recommendations for that specific onboarding conversation; otherwise falls back to the most recent onboarding conversation. Returns empty recommendations array if no conversations exist. WARNING: Only to be used by RBC Service, not for direct client use since Content Rec\'s must be passed through RBC security filtering rules
     * @summary Get AI recommendations
     * @param {string} [conversationId] Optional UUID of a specific onboarding conversation to retrieve recommendations for. If omitted, returns recommendations for the most recent onboarding conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterAiRecommendationsGetAIRecommendationsV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterAiRecommendationsGetAIRecommendationsV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/conversations/{conversation_type}`
     * Creates a new AI conversation based on the conversation type.  **Note:** User goals or topics are automatically fetched from the Usercrypt Service using the authenticated recipient ID. Use the `include` query parameter to select which data is included (default: goals).
     * @summary Create an AI conversation
     * @param {AiRouterConversationsCreateConversationByTypeV1ConversationTypeEnum} conversationType The type of conversation (e.g., onboarding, journaling)
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {ConversationRequest} conversationRequest
     * @param {AiRouterConversationsCreateConversationByTypeV1IncludeEnum} [include] Which data to include with the conversation request. Only applies to onboarding conversations; ignored for journaling. Valid values are \&quot;goals\&quot; or \&quot;topics\&quot;. Defaults to \&quot;goals\&quot; for backward compatibility.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterConversationsCreateConversationByTypeV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterConversationsCreateConversationByTypeV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/conversations/{conversation_id}/items`
     * Retrieves all items (messages) for a specific conversation in chronological order. Returns user and assistant messages in a format inspired by the OpenAI Conversations API.
     * @summary Get conversation items
     * @param {string} conversationId The conversation ID to retrieve items for
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterConversationsGetConversationItemsV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterConversationsGetConversationItemsV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/conversations`
     * Retrieves all non-deleted conversations for a specific recipient and conversation type
     * @summary Get conversations for a recipient
     * @param {AiRouterConversationsGetConversationsV1ConversationTypeEnum} conversationType The type of conversation to filter by
     * @param {number} recipientId The Circle recipient ID to get conversations for
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {AiRouterConversationsGetConversationsV1StateEnum} [state] Optional filter for conversation state
     * @param {string} [pageCursor] Cursor for keyset pagination. Pass the value from links.next to fetch the next page.
     * @param {number} [pageSize] Number of conversations per page (default 25, max 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterConversationsGetConversationsV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterConversationsGetConversationsV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/pipelines/retry`
     * Scans failed inputs of a given operation type within a creation-time window and re-enqueues them onto the in-process pipeline worker. This endpoint is append-only:  failed inputs are never mutated. The pipeline worker creates a new input row for each  attempt, which becomes the conversation\'s latest — so a subsequent retry call will  not re-process the same conversation.
     * @summary Re-queue failed Content RAG pipeline jobs
     * @param {PipelineRetryRequest} pipelineRetryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterPipelinesRetryV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterPipelinesRetryV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/pubsub`
     * Generic endpoint for handling Google Cloud Pub/Sub push subscription messages This endpoint receives push messages from Google Cloud Pub/Sub and processes them asynchronously. The endpoint validates the Pub/Sub message format and routes events to appropriate handlers based on event type.
     * @summary Pub/Sub message receiving endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterPubsubV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterPubsubV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/recipients/{recipient_id}/copy`
     * Copies all Conversations, Inputs, Responses, and related data from the source User Circle (recipient_id) to a target User Circle. The operation is atomic and idempotent. If the target circle already has any data, the copy operation is skipped and returns 204 No Content without making changes.  Authorization: callers must be either a service (M2M) token holding the `write:admin` permission, or a member whose Circle JWT recipient matches the `recipient_id` path parameter and grants create permission on the AI data classes. A bare authenticated token without either is rejected.
     * @summary Copy conversations and related data to a new User Circle
     * @param {number} recipientId The source User Circle ID (recipient_id) to copy data from
     * @param {RecipientCopyRequest} recipientCopyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterRecipientsCopyRecipientDataV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterRecipientsCopyRecipientDataV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/recipients/{recipient_id}/conversations/{conversation_id}`
     * Soft-deletes a conversation by setting its deleted_at timestamp. The conversation will no longer appear in any GET queries.
     * @summary Soft delete a conversation
     * @param {number} recipientId The Circle recipient ID that owns the conversation
     * @param {string} conversationId The conversation ID to delete
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterRecipientsDeleteConversationV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterRecipientsDeleteConversationV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/recipients/{recipient_id}/expunge`
     * Hard-deletes all conversations, inputs, responses, and feedback for the given recipient ID. Unlike soft-delete, this operation is irreversible and physically removes the rows from the database. Cascading foreign key constraints ensure that all child records (inputs, responses, feedback) are removed when their parent conversations are deleted.
     * @summary Permanently expunge all data for a recipient
     * @param {number} recipientId The Circle recipient ID whose data will be permanently deleted
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterRecipientsExpungeV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterRecipientsExpungeV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/recipients/{recipient_id}/journaling/time-spent`
     * Returns the total time spent across all journaling conversations for a recipient (including deleted ones).
     * @summary Get total journaling time spent
     * @param {number} recipientId The Circle recipient ID
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterRecipientsGetJournalingTimeSpentV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterRecipientsGetJournalingTimeSpentV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/recipients/{recipient_id}/conversations/{conversation_id}`
     * Increments the time_spent_seconds for a conversation by the specified amount. Multiple calls accumulate additively. Cannot update deleted or completed conversations.
     * @summary Update conversation time spent
     * @param {number} recipientId The Circle recipient ID that owns the conversation
     * @param {string} conversationId The conversation ID to update
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {IncrementConversationTimeSpentRequest} incrementConversationTimeSpentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterRecipientsUpdateConversationTimeSpentV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterRecipientsUpdateConversationTimeSpentV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/responses/{response_id}/feedback`
     * Submits user feedback for AI-generated content, persisting it to the database and sending to BigQuery and Databricks.  Supports three types of feedback: - **Content Level (ai_content_rec_single)**: Feedback for a single piece of content (e.g., a specific guide) - **Care Plan Level (ai_content_rec_group)**: Feedback for a group of content recommendations (e.g., full care plan) - **Echo Back (ai_echo_back)**: Feedback for empathetic responses generated in the Echo Back flow  All types are associated with the same Databricks trace ID from the response. The contentId is required only for ai_content_rec_single to identify the specific content being rated. For ai_content_rec_group and ai_echo_back, the response_id provides sufficient context.
     * @summary Submit user feedback for AI content
     * @param {string} responseId The ID of the AI response - used to retrieve the Databricks trace ID for evaluation tracking
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {FeedbackRequest} feedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterResponsesCreateFeedbackV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterResponsesCreateFeedbackV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/responses`
     * Adds a new response to an existing journaling conversation. The conversation must already exist, not be completed, and be of type \"journaling\". Only journaling conversations are supported — onboarding conversations are single-turn and should use PUT /v1/ai-router/conversations/onboarding instead.
     * @summary Continue an existing journaling conversation
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {CreateResponseRequest} createResponseRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterResponsesCreateResponseV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterResponsesCreateResponseV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/ai-router/responses/{response_id}/feedback`
     * Retrieves all feedback submitted for a specific response. Returns feedback filtered by the authenticated user\'s recipient_id for proper authorization. Used by clients to determine which feedback button state to show (thumbs up, thumbs down, or no vote).
     * @summary Get feedback for a response
     * @param {string} responseId The ID of the AI response to retrieve feedback for
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiRouterResponsesGetFeedbackV1(params, options) {
        return (0, exports.AiRouterApiFp)(this.configuration)
            .aiRouterResponsesGetFeedbackV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.AiRouterApi = AiRouterApi;
exports.AiRouterConversationsCreateConversationByTypeV1ConversationTypeEnum = {
    Onboarding: 'onboarding',
    Journaling: 'journaling',
};
exports.AiRouterConversationsCreateConversationByTypeV1IncludeEnum = {
    Goals: 'goals',
    Topics: 'topics',
};
exports.AiRouterConversationsGetConversationsV1ConversationTypeEnum = {
    Onboarding: 'onboarding',
    Journaling: 'journaling',
};
exports.AiRouterConversationsGetConversationsV1StateEnum = {
    Completed: 'completed',
};
//# sourceMappingURL=ai-router-api.js.map